import Visit from '../../visit';
import Select from '../../select/index';
import { updateCubeList } from '../../../update/updateCubeList';
import { runForceUpdate } from '../../../update/runForceUpdate';
import { updateAllShelfsClass } from '../../../update/updateAllShelfsClass';
import { updateEnd } from '../../../update/updateEnd';

// 撤销
async function shelfDragMoveStackOut(stackOutItem: StackOutItem|null): Promise<void> {
    stackOutItem.data.forEach((moveTask: MoveTask): void => {
        let moveCubeIds: CubeId[] = getMoveCubes(moveTask);

        Visit.Move.logic(moveTask.logic);
        Select.clear();
        Select.addGroup(moveCubeIds);
        Select.panelSelectAsync();
        updateAllShelfsClass();
        updateEnd();
    });
}

function getMoveCubes(moveTask: MoveTask): CubeId[] {
    let result: Set<CubeId> = new Set();

    moveTask.logic.forEach((logicTask: LogicMoveTask): void => {
        result.add(logicTask.to.moveTarget);
    });
    moveTask.physics.forEach((physicsTask: PhysicsMoveTask): void => {
        result.add(physicsTask.to.moveTarget);
    });

    return Array.from(result);
}

export {
    shelfDragMoveStackOut
};
